<template>
  <div class="row">
    <div class="tools">
      <svg
        @click="$emit('delete-item', fooditem.id)"
        xmlns="http://www.w3.org/2000/svg"
        width="24" height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        style="cursor: pointer; color: red;"
      >
        <polyline points="3 6 5 6 21 6"></polyline>
        <path d="M19 6l-1 14H6L5 6"></path>
        <path d="M10 11v6"></path>
        <path d="M14 11v6"></path>
        <path d="M9 6V4h6v2"></path>
      </svg>
    </div>
<div
  class="foodname"
  :style="{ width: doseratio > 0 ? 'calc(55% - 50px)' : 'calc(70% - 50px)' }"
>
  {{ fooditem.name }}
  <span v-if="showCarbs">
  ({{ Number(fooditem.carbs).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) }})
</span>

</div>

    <!--div class="foodname">
      {{ fooditem.name }}
      <span v-if="showCarbs"> ({{ fooditem.carbs }})</span>
    </div-->

    <div>
      <input
        type="tel"
        inputmode="numeric"
        class="foodweight"
        min="0"
        maxlength="3"
        v-model="weightProxy"
        placeholder=""
      />
    </div>

    <div v-if="doseratio > 0">{{ insulinDosePerWeight }}</div>
    <div>{{ carbsPerWeight }}</div>
  </div>
</template>

<script>
export default {
  name: "FoodRow",
  props: {
    fooditem: { type: Object, required: true },
    doseratio: { type: Number, default: 1 },
    showCarbs: { type: Boolean, default: false },
  },
  computed: {
    weightProxy: {
      get() {
        return this.fooditem.weight === 0 ? "" : this.fooditem.weight;
      },
      set(val) {
        this.fooditem.weight = val === "" ? 0 : Number(val);
        this.$emit("updated", this.fooditem);
      },
    },
    carbsPerWeight() {
      const weight = Number(this.fooditem.weight) || 0;
      if (!weight) return "";
      return ((weight * Number(this.fooditem.carbs || 0)) / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },
    insulinDosePerWeight() {
      const weight = Number(this.fooditem.weight) || 0;
      if (!weight) return "";
      return ((weight * Number(this.fooditem.carbs || 0)) / 100 / this.doseratio).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },
  },
};
</script>

<style scoped>
.row {
  display: block;
  width: 100%;
  margin: 0;
}

.row div {
  color: #000;
  display: inline-block;
  width: 15%;
  font-family: calibri;
  text-align: center;
  padding: 10px 0;
}

.row div.tools {
  width: 50px;
  min-width: 50px;
}

.row div.foodname {
  text-align: right;
  padding-right:5px;
  text-transform: uppercase;
}

.row div.foodname span {
  font-size: 12px;
}

input.foodweight {
  width: 100%;
  max-width: 35px;
}
</style>
